
import Vue from "vue";
import UIFeatureMixinVue from "@/mixins/UIFeatureMixin.vue";
import axios from "axios";
import { IContactUsModel, AgenciesOfContactTypeModel } from "@/types";
import AppPropsMixin from "@/mixins/AppPropsMixin.vue";
import store from "@/store";
import { VueConstructor } from "vue/types/umd";
import ExpansionPanelTemplate from "@/components/common/ExpansionPanelTemplate.vue";
import ContactusContentMult from "@/components/contact/ContactusContentMult.vue";
import { UI_ENDPOINT } from "@/constants/EndPoints";
import AccessibilityMixin from "@/mixins/AccessibilityMixin.vue";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof UIFeatureMixinVue>>
).extend({
  name: "contactUs",
  components: { ExpansionPanelTemplate, ContactusContentMult },
  mixins: [UIFeatureMixinVue, AppPropsMixin, AccessibilityMixin],
  data() {
    return {
      countyCode: "" as string,
      showProgressBar: false,
      contactUsContent: [] as IContactUsModel[],
      contactUsAllContent: {} as AgenciesOfContactTypeModel,
    };
  },
  created() {
    if (this.filteredCounties.length === 0) {
      let url = UI_ENDPOINT.GET_FILTERED_COUNTIES;
      store.dispatch.dataModule.getFilteredCounties(url);
    }
  },
  mounted() {
    //@ts-ignore
    this.setAriaLabelledByForSelect(
      this.$refs.contact_us_county_select_ref,
      "contact_us_choose_county_id"
    );
  },
  computed: {
    filteredCounties() {
      return store.getters.dataModule.getFilteredCountiesInStore;
    },
  },
  methods: {
    getAgenciesByCounty(resourceCode: string) {
      this.showProgressBar = true;
      let url = UI_ENDPOINT.GET_ALL_CONTACTUS_AGENCIES_DETAILS_BY_CNTY;
      axios
        .get(url, {
          params: {
            countyCode: resourceCode,
          },
        })
        .then((response) => {
          this.contactUsAllContent = response.data;
        })
        .catch((error) => {
          store.dispatch.alertModule.showAlertMessageById(
            error.response.data.id
          );
        })
        .finally(() => {
          this.showProgressBar = false;
        });
    },
  },
});
